import Role from '../../components/team/role/table/Component.js';

export default function Component() {

    return (
        <>
            <Role name="All Roles" />
        </>
    );
}